import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse ,HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';

import 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/throw';

@Injectable()
export class ShoppingPrecoProvider {

  apiRoot: string = 'http://192.99.185.73:8070';
  apiRootSDP: string = 'http://66.70.157.102:8071';

  constructor(public http: HttpClient) {
    console.log('Hello ShoppingPrecoProvider Provider');
  }

  getShoppingPrecos(CodigoVendedor: string, CategoryMLB: string, Limite: string){

    const header = new HttpHeaders({ 'Content-Type':  'application/json', 'Authorization': 'bearer ' + localStorage.getItem('userToken') })

    return this.http
      .get(this.apiRoot + '/Vendedor/ListarShoppingPreco?codigosVendedor=' + CodigoVendedor + '&categoriaMLB=' + CategoryMLB + '&limit=' + Limite, { headers: header })
      .do(data => JSON.stringify(data))
      .catch(this.handleError);
  }

  vincularShopingPreco(CodigoMLB: string, CodigoSKU){

    const header = new HttpHeaders({ 'Content-Type':  'application/json', 'Authorization': 'bearer ' + localStorage.getItem('userToken') })

    let username = localStorage.getItem('userLogin');

    return this.http

      // .post(this.apiRoot + '/Anuncios/VincularShoppingPrecos?Mlb=' + Codigo + '&email=' + JSON.parse(Email).user_mail, Array.from(Codigo), { headers: header })

      .post(this.apiRootSDP + '/Concorrente/CriarRelacionamento' , {
        "Mlb": CodigoMLB,
        "CodigoExternoPai": CodigoSKU,
        "Usuario": JSON.parse(username).user_id
      }, { headers: header })
      .do(data => JSON.stringify(data))
      .catch(this.handleError);
  }

  revisarVinculoShoppingPrecos(CodigoMLB: string){

    const header = new HttpHeaders({ 'Content-Type':  'application/json', 'Authorization': 'bearer ' + localStorage.getItem('userToken') })

    let userEmail = localStorage.getItem('userLogin');

    return this.http

      // .post(this.apiRoot + '/Anuncios/VincularShoppingPrecos?Mlb=' + Codigo + '&email=' + JSON.parse(Email).user_mail, Array.from(Codigo), { headers: header })

      .post(this.apiRoot + '/Anuncios/RevisarVinculoShoppingPrecos?'
                            + 'Mlb=' + CodigoMLB
                            + '&email=' + JSON.parse(userEmail).user_mail, { }, { headers: header })
      .do(data => JSON.stringify(data))
      .catch(this.handleError);
  }

  private handleError(error: HttpErrorResponse){

    let errorMessage = {};
    if (error.error instanceof Error) {

        // A client-side or network error occurred. Handle it accordingly.
        errorMessage = `An error occurred: ${error.error.message}`;
        console.log(error.error);

    } else {

        // The backend returned an unsuccessful response code.
        // The response body may contain clues as to what went wrong,
        errorMessage = { status: error.status, message: error.error.Message };
        console.log(error.error);

        if(error.status == 401){

        }

    }

    return Observable.throw(errorMessage);
  }

}



// WEBPACK FOOTER //
// ./src/providers/shopping-preco/shopping-preco.ts